export const getDeliveryInterval = ({ min = '', max = '' } = {}) => {
  // 1, 2, 3 дня только минимум, все что больше 3-5 дней с мин и макс
  return min && max
    ? min === max ? max : min + '-' + max
    : min || max;
};
